/**
 * Ice Storm Fusion Anomaly marker styling (operator-cop-doctrine §3B.8 queue-anomaly
 * marker doctrine, §3A.7 context-locked palette; §4.5 ice-storm picture).
 *
 * Unlike the smoke_detected anomaly (an UNSCORED amber "needs eyes" dot), the
 * ice-storm anomaly is a SCORED queue anomaly — it carries an IMS Response Level, so
 * it reuses the Response-Level palette + pulsing-dot treatment (styles/responseLevel.ts,
 * the same family as the fused-hotspot dots). What distinguishes it from a fire dot is
 * the CAHS ice-storm kind-glyph riding inside the dot (#305 — `cahs:ice-storm` via
 * iconRegistry, see layers/anomalyMarker `hazardGlyphBillboard`). Colour is never
 * load-bearing alone: the dot is always paired with the "Response Level N" badge in
 * the queue + panel and the glyph on the map.
 *
 * This is the act-register signal that sits ON TOP of the ambient Power Outages layer
 * (§4.28) — that ambient render is untouched; this is the anomaly on top.
 */

/** Badge sub-label by anomaly type — pairs with the Response Level badge. */
export function iceTypeLabel(anomalyType: string): string {
  return anomalyType === 'anticipatory' ? 'Anticipatory · pre-impact' : 'Impact event';
}
